import instance from "@/utils/request";

// function postRequest(url, data) {
//   return new Promise(function (resolve, reject) {
//     instance({
//       url: url,
//       method: "post",
//       data,
//     }).then(
//       (res) => {
//         resolve(res.data);
//       },
//       (err) => {
//         reject(err);
//       }
//     );
//   });
// }

function getRequest(url, params) {
  return new Promise(function (resolve, reject) {
    instance({
      url: url,
      method: "get",
      params,
    }).then(
      (res) => {
        resolve(res.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

export function queryBusiness(businessId) {
  return getRequest(`/website/businessMovement/${businessId}`);
}

export function getUpDown(params) {
  return getRequest(`/website/businessMovement/searchUpDown`, params);
}
